import React, { useState } from 'react'

export interface IAppContext {
    HasAnalyticsRendered: boolean
    setHasAnalyticsRendered: (value: boolean) => void
}

// make and export the context
// exports object with name, Provider and Consumer
export const AppContext = React.createContext<IAppContext>({} as IAppContext)

/**
 * Props for the AppContextProvider
 */
export interface IAppContextProviderProps {
    children: JSX.Element | JSX.Element[]
}

/**
 * Writes the AppContext as a parent to the children.
 * Exposes the methods required to set the state and maintains it too.
 * @param {IAppContextProviderProps} props child components consuming the context
 * @returns JSX.Element children
 */
function AppContextProvider(props: IAppContextProviderProps) {
    const [HasAnalyticsRendered, hasAnalyticsRendered] = useState(false)

    function setHasAnalyticsRendered(value: boolean) {
        hasAnalyticsRendered(value)
    }

    return (
        <AppContext.Provider
            value={{ HasAnalyticsRendered, setHasAnalyticsRendered }}>
            {props.children}
        </AppContext.Provider>
    )
}

export default AppContextProvider
